import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoFormacaoPorEscolaSolicitacao.vue?vue&type=template&id=4b4dba98&scoped=true"
import script from "./RelatorioSinteticoAnaliticoFormacaoPorEscolaSolicitacao.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoFormacaoPorEscolaSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSinteticoAnaliticoFormacaoPorEscolaSolicitacao.vue?vue&type=style&index=0&id=4b4dba98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dba98",
  null
  
)

export default component.exports